// extracted by mini-css-extract-plugin
export default {"row":"dz3GUqUf","ad-site-wrapper-small":"ad-site-wrapper-small","type1":"GBTaiNlA","content":"wuvv6LaW","image":"UUY6ZwEs","beautyTime":"tgqdihyc","time":"PYLCLnKV"};